import { Redirect } from "react-router";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import AppLoading from "../../Components/General/AppLoading";
import React from "react";
const AadCallback = () => {
    // Not sure if this is used. MsalProvider probably takes control before getting here?
    const isAuthenticated = useIsAuthenticated();
    if (isAuthenticated) {
        const localUrl = window.sessionStorage.getItem("local-url") || "/";
        window.sessionStorage.removeItem("local-url");
        return <Redirect to={localUrl} />;
    }
    return (
        <>
            <h1 style={{ height: "50%", width: "50%", backgroundColor: "red" }}>
                blaablaa
            </h1>
            <AppLoading />
        </>
    );
};
export default AadCallback;
